import React, {useEffect} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import {setAgreeEmailCheckbox} from "../../actions/serverFunctions";
import Config from "../../config";
import UiIcon from "../ui/icons/uiIcon";

const AgreeEmailCheckbox = (props) => {

  const {setAgreeEmailCheckbox, agreeEmailCheckbox, fabricatorData, assignQuotePopupSaveButtons} = props;

  useEffect(() => {
    if (fabricatorData.settings.useFabricatorCostPrices && agreeEmailCheckbox) {
      setAgreeEmailCheckbox(!agreeEmailCheckbox);
    }
  }, [fabricatorData, agreeEmailCheckbox, setAgreeEmailCheckbox]);

  const agreeEmailCheckboxVisible = (Config.isDevMode() || document.kvConfig.isBackend) && !fabricatorData.isCaesarStone
    && (assignQuotePopupSaveButtons !== "updateTax");

  if (!agreeEmailCheckboxVisible) {
     return null
  }

  const disabled = fabricatorData.settings.useFabricatorCostPrices;

  const agreeEmailCheckboxClick = () => {
    if (disabled) {
      return false
    }
    setAgreeEmailCheckbox(!agreeEmailCheckbox);
  };

  return (
    <button className="ui-checkbox-wrapper" onClick={agreeEmailCheckboxClick} title={disabled ? "Cost prices are on" : ""}>
      <div className={"ui-checkbox ui-checkbox--small" + (agreeEmailCheckbox ? " ui-checkbox--checked-svg" : "")
        + (disabled ? " ui-checkbox--disabled" : "")}>
        <div className="ui-checkbox__svg">
          <UiIcon icon="checkmark"/>
        </div>
      </div>
      <span className={"ui-checkbox__label ui-checkbox__text" + (disabled ? " ui-checkbox__label--disabled" : "")}>
        <FormattedMessage id="assignPopup.emailAgreeCheckbox"/>
      </span>
    </button>
  )
};

const mapStateToProps = (store) => {
  const {assignQuotePopupSaveButtons} = store.assignQuoteState;

  return {
    agreeEmailCheckbox: store.serverState.agreeEmailCheckbox,
    fabricatorData: store.fabricatorState,
    assignQuotePopupSaveButtons,
  };
};

const mapDispatchToProps = {
  setAgreeEmailCheckbox
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(AgreeEmailCheckbox)
)
